goog.provide('yext.location.FacebookCta');
goog.provide('yext.location.FacebookCtaModel');

goog.require('yext');
goog.require('yext.location.Select');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

/**
 * Model for the facebook cta field
 *
 * @param {!Object} data
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
yext.location.FacebookCtaModel = function(data) {
  this.set(data);
};

/**
 * Set values on the model, checking for changes
 *
 * @param {!Object} data
 * @return {boolean} True if the update changes the model
 */
yext.location.FacebookCtaModel.prototype.set = function(data) {
  var changed = false;
  if (yext.isString(data.type) && data.type != this.type) {
    changed = true;
    this.type = data.type;
  }
  if (yext.isString(data.value) && data.value != this.value) {
    changed = true;
    this.value = data.value;
  }
  if (yext.isBoolean(data.isCustomValue) && data.isCustomValue != this.isCustomValue) {
    changed = true;
    this.isCustomValue = data.isCustomValue;
  }
  if (yext.isBoolean(data.indeterminate) && data.indeterminate != this.indeterminate) {
    changed = true;
    this.indeterminate = data.indeterminate;
  }
  return changed;
};

/**
 * Calls set and optionally triggers an update message
 *
 * @param {!Object} data
 */
yext.location.FacebookCtaModel.prototype.update = function(data) {
  if (this.set(data)) {
    this.message('updated');
  }
};

/**
 * Trigger a message on the FacebookCtaModel
 *
 * @param {string} message Message to trigger
 */
yext.location.FacebookCtaModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Models the Facebook Call-to-Action field.
 *
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
yext.location.FacebookCta = function($ctx) {
  this.$ctx = $ctx;
  this.$linkedFieldValue = $ctx.find('.js-use-field-value');

  this.fieldName = this.$ctx.find('input[name="field"]').val();
  this.type = new yext.location.Select($ctx.find('.js-facebook-cta-type'));
  this.phone = new yext.location.Select($ctx.find('.js-use-field-phone'));
  this.url = new yext.location.Select($ctx.find('.js-use-field-url'));
  this.email = new yext.location.Select($ctx.find('.js-use-field-email'));

  this.init();
  this.storeValue();
  this.bindType();
  this.bindUseField();
  this.bindLinkedFieldValue();
  this.bindUpdates();
  this.bindReset();
};

/**
 * Initializes the data
 */
yext.location.FacebookCta.prototype.init = function() {
  this.useFieldTypeMap = this.$ctx.data('useFieldTypeMap');
  this.useFieldValueMap = this.$ctx.data('useFieldValueMap');

  this.initModel();
};

/**
 * Initializes the data model
 */
yext.location.FacebookCta.prototype.initModel = function() {
  var value = '';
  var isCustomValue = false;
  var displayUseField = this.getDisplayUseField();
  if (displayUseField !== undefined) {
    var useField = displayUseField.getValue();
    if (useField === 'CUSTOM VALUE') {
      value = this.useFieldValueMap[useField].value;
      isCustomValue = true;
    } else {
      value = displayUseField.getValue();
    }
  }
  this.model = new yext.location.FacebookCtaModel({
    type: this.type.getValue(),
    value: value,
    isCustomValue: isCustomValue,
    indeterminate: this.$ctx.find('.js-field-indeterminate').val() === 'true',
  });
};

/**
 * Gets the display use field select dropdown that corresponds to the selected type
 *
 * @return {!Object} The use field that corresponds to the selected type
 */
yext.location.FacebookCta.prototype.getDisplayUseField = function() {
  var useFieldType = this.useFieldTypeMap[this.type.getValue()];
  var displayUseField;
  if (useFieldType === 'phone') {
    displayUseField = this.phone;
  } else if (useFieldType === 'url') {
    displayUseField = this.url;
  } else if (useFieldType === 'email') {
    displayUseField = this.email;
  } else if (useFieldType === 'none') {
    displayUseField = undefined;
  }

  return displayUseField;
};

/**
 * Stores the model so that it can be restored later
 */
yext.location.FacebookCta.prototype.storeValue = function() {
  this.storedModel = new yext.location.FacebookCtaModel(this.model);
};

/**
 * Binds the type dropdown change
 */
yext.location.FacebookCta.prototype.bindType = function() {
  var self = this;
  $(this.type).on('updated', function() {
    var displayUseField = self.getDisplayUseField();
    var type = this.getValue();
    var value = '';
    if (displayUseField !== undefined) {
      displayUseField.setDefaultOption();
      value = displayUseField.getValue();
    }
    self.model.update({
      type: type,
      value: value,
      isCustomValue: false,
    });
  });
};

/**
 * Binds the use field dropdown change and updates the use field input value
 */
yext.location.FacebookCta.prototype.bindUseField = function() {
  var self = this;

  $(self.phone).on('updated', function() {
    self.updateValue(this);
  });

  $(self.url).on('updated', function() {
    self.updateValue(this);
  });

  $(self.email).on('updated', function() {
    self.updateValue(this);
  });
};

/**
 * Updates the model's value
 *
 * @param {!Object} select The select object
 */
yext.location.FacebookCta.prototype.updateValue = function(select) {
  var value;
  var isCustomValue = false;
  if (select.getValue() === 'CUSTOM VALUE') {
    value = this.useFieldValueMap[select.getValue()].value;
    isCustomValue = true;
  } else {
    value = select.getValue();
  }

  this.model.update({
    value: value,
    isCustomValue: isCustomValue,
  });
};

/**
 * Binds the use field input change
 */
yext.location.FacebookCta.prototype.bindLinkedFieldValue = function() {
  var self = this;
  this.$linkedFieldValue.inputchange(function() {
    self.model.update({
      value: $(this).val(),
      isCustomValue: true,
    });
  });
};

/**
 * Binds the reset link in bulk edit case
 */
yext.location.FacebookCta.prototype.bindReset = function() {
  var self = this;
  this.$ctx.find('.js-reset-facebook-cta').click(function() {
    self.model.update({
      indeterminate: false,
    });
  });
};

/**
 * Reset the field to the stored state
 */
yext.location.FacebookCta.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Sets the fields value
 *
 * @param {!Object} field
 */
yext.location.FacebookCta.prototype.set = function(field) {
  this.model.update(field);
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.FacebookCta.prototype.bindUpdates = function() {
  var self = this;
  $(this.model).on('updated', function() {
    self.render();
    self.message('updated');
  });
};

/**
 * Render the edit mode using the current state of the model
 */
yext.location.FacebookCta.prototype.render = function() {
  this.phone.$ctx.hide();
  this.url.$ctx.hide();
  this.email.$ctx.hide();
  this.$linkedFieldValue.hide();

  if (this.model.indeterminate) {
    this.type.$ctx.hide();
    this.$ctx.find('.js-indeterminate-message').show();
    return;
  } else {
    this.$ctx.find('.js-facebook-cta-use-field').show();
    this.type.$ctx.show();
    this.$ctx.find('.js-indeterminate-message').hide();
  }

  this.type.set({'value': this.model.type});
  var displayUseField = this.getDisplayUseField();
  if (displayUseField !== undefined) {
    if (this.model.isCustomValue) {
      displayUseField.set({'value': 'CUSTOM VALUE'});
    } else {
      displayUseField.set({'value': this.model.value});
    }
    displayUseField.$ctx.show();
    this.toggleLinkedFieldValue();
  }
};

/**
 * Toggles the display use field input based on the selected field
 */
yext.location.FacebookCta.prototype.toggleLinkedFieldValue = function() {
  this.$linkedFieldValue.show();

  if (this.model.isCustomValue) {
    if (this.$linkedFieldValue.val() != this.model.value) {
      this.$linkedFieldValue.val(this.model.value);
    }
  } else {
    var value = '';
    if (this.useFieldValueMap[this.model.value] !== undefined) {
      value = this.useFieldValueMap[this.model.value].value;
    }
    this.$linkedFieldValue.val(value);
  }

  this.$linkedFieldValue.prop('disabled', !this.model.isCustomValue);
};

/**
 * Publish a message with the field as the context
 *
 * @param {string} message Message to trigger
 */
yext.location.FacebookCta.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Gets the display value of the field (view mode)
 */
yext.location.FacebookCta.prototype.getDisplayValue = function() {
  var display;
  if (this.model.value === '') {
    // For types that don't have use fields, e.g. 'NONE', 'Send Message'
    display = this.type.labels[this.model.type];
  } else if (this.model.isCustomValue) {
    // TRANSLATORS: {0} is an action like 'Call Now' or 'Contact us'
    display = yext.msg('{0} using custom value', this.type.labels[this.model.type]) +
              ' ' + this.$linkedFieldValue.val();
  } else {
    var displayUseField = this.getDisplayUseField();
    var value = '';
    if (this.useFieldValueMap[this.model.value] !== undefined) {
      value = this.useFieldValueMap[this.model.value].value;
    }
    // TRANSLATORS: {0} is an action like 'Call Now' or 'Contact us' {1} is a value like
    // a phone number or email address
    display = yext.msg('{0} using {1}', this.type.labels[this.model.type], displayUseField.labels[this.model.value]) +
              ' ' + value;
  }
  return display;
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.FacebookCta.prototype.getJSONData = function() {
  return yext.JSON.stringify({
    'type': this.model.type,
    'value': this.model.value,
    'isCustomValue': this.model.isCustomValue,
  });
};
